import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Layout, Typography } from 'antd';

import {
  PRIVACY_POLICY_PATH,
  TERMS_OF_SERVICE_PATH,
} from '../../../../../constants/routes';
import { useHomeMessageId } from '../../../hooks/useHomeMessageId';

import { ReduxState } from '../../../../../types/app';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const footerItems = [
  {
    labelKey: 'footer.email.label',
    valueKey: 'footer.email.value',
  },
  {
    labelKey: 'footer.phone.label',
    valueKey: 'footer.phone.value',
  },
  {
    labelKey: 'footer.address.label',
    valueKey: 'footer.address.value',
  },
];

const footerLinks = [
  {
    labelKey: 'footer.terms',
    to: TERMS_OF_SERVICE_PATH,
  },
  {
    labelKey: 'footer.privacy',
    to: PRIVACY_POLICY_PATH,
  },
];

const Footer = () => {
  const homeMessageId = useHomeMessageId();
  const homeIndex = useSelector(
    (state: ReduxState) => state.Data.config?.home ?? 0
  );

  return (
    <AntFooter className="home-page__footer" id="contacts">
      <div className="home-page__footer-brand">
        <strong className="home-page__footer-brand-name">
          <FormattedMessage id={homeMessageId('brand')} />
        </strong>
        {homeIndex === 1 && (
          <div className="home-page__footer-disclaimer">
            <FormattedMessage id={homeMessageId('footer.disclaimer')} />
          </div>
        )}
        <Text className="home-page__footer-copyright">
          <FormattedMessage id={homeMessageId('footer.copyright')} />
        </Text>
        <div className="home-page__footer-links">
          {footerLinks.map(({ labelKey, to }) => (
            <a
              className="home-page__footer-link"
              href={to}
              key={labelKey}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FormattedMessage id={homeMessageId(labelKey)} />
            </a>
          ))}
        </div>
      </div>
      {footerItems.map(({ labelKey, valueKey }) => (
        <div className="home-page__footer-item" key={labelKey}>
          <Text className="home-page__footer-label">
            <FormattedMessage id={homeMessageId(labelKey)} />
          </Text>
          <strong className="home-page__footer-value">
            <FormattedMessage id={homeMessageId(valueKey)} />
          </strong>
        </div>
      ))}
    </AntFooter>
  );
};

export default Footer;
